<section class="text-center grid">
  <div class="p-offset-0 col-12 md:col-6 md:col-offset-3">
    <p-card>
      <img src="/assets/images/Aline_logo-12.png" alt="Aline" width="200" />

      @if (errorMessage) {
        <div class="p_field mb-4">
          <p-message severity="error" data-cy="sso-login-message">{{
            errorMessage
          }}</p-message>
        </div>
      }

      @if (selectActiveOrganizationUnit) {
        <div>
          <div>
            <p-select
              [name]="'organizationUnit'"
              [id]="'organizationUnit'"
              [options]="organizationUnits"
              [optionLabel]="'name'"
              [optionValue]="'id'"
              [(ngModel)]="selectedOrganizationUnit"
              placeholder="{{ 'common.select-organization-unit' | translate }}"
              data-cy="organization-unit-select"
            ></p-select>
          </div>
          <div class="mt-2">
            <button
              pButton
              [type]="'button'"
              (click)="selectOrganization()"
              [disabled]="!selectedOrganizationUnit"
              data-cy="organization-unit-select-button"
            >
              Select
            </button>
          </div>
        </div>
      } @else {
        <section class="mt-2">
          @if (loginEvent === 'start' && !retry) {
            <div>
              {{ 'sso-login.redirect' | translate }}
            </div>
          }
          @if (loginEvent === 'confirm' && !retry && !errorMessage) {
            <div>
              {{ 'sso-login.confirming' | translate }}
            </div>
          }
        </section>

        <section class="mt-2">
          @if (retry) {
            <button
              pButton
              [type]="'button'"
              (click)="startLogin()"
              class="mr-4"
            >
              {{ 'sso-login.btn-try-again' | translate }}
            </button>
          }
          <button
            pButton
            [type]="'button'"
            [routerLink]="['/login']"
            class="p-button-secondary"
          >
            {{ 'common.button.cancel' | translate }}
          </button>
        </section>
      }
    </p-card>
  </div>
</section>
